<template>
  <div>
    <aw-store v-if="!loading && selectedStore" :stores="stores" :selected-store="selectedStore" />
    <aw-spinner v-if="loading" color="currentColor" :class="$style.spinner" />
  </div>
</template>

<script setup lang="ts">
  import { useStoresAndPetrolsStore } from '~~/common/stores/storesAndPetrolsStore';
  import { computed, defineAsyncComponent, ref } from 'vue';
  import { defineI18nRoute } from '#i18n';
  import { useAsyncData, useNuxtApp } from 'nuxt/app';
  import { setErrorNotification } from '~~/common/utils/helper';
  import { useSeoStore } from '~~/common/stores/seo.js';
  import { SEO_MODULE_STORE } from '~~/common/config/SeoConfig';
  import AwSpinner from '~~/common/components/Common/AwSpinner.vue';

  const AwStore = defineAsyncComponent(() => import('~~/shop/app/components/Page/Store/AwStore.vue'));

  const nuxtApp = useNuxtApp();
  const { $logger } = nuxtApp;

  defineOptions({
    name: 'StoresPage',
  });

  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/stores',
      hu: '/aruhazak',
    },
  });

  const storesAndPetrolsStore = useStoresAndPetrolsStore();
  const seoStore = useSeoStore();

  const loading = ref(false);

  const stores = computed(() => storesAndPetrolsStore.stores);

  const dataKey = 'stores';
  const { data: selectedStore } = await useAsyncData(
    dataKey,
    async () => await fetchStores(),
    {
      default: () => null,
    },
  );

  async function fetchStores () {
    loading.value = true;
    try {
      await storesAndPetrolsStore.fetchAuchanStores();
      const firstStore = storesAndPetrolsStore.stores[0];
      await seoStore.fetchSeoData({
        seoModule: SEO_MODULE_STORE,
        id: firstStore?.id,
      });
      loading.value = false;
      return firstStore ?? null;
    } catch (error) {
      $logger.error(error);
      setErrorNotification({
        nuxtApp,
        error,
      });
      return null;
    }
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.spinner {
  color: $color-text-primary;
}
</style>

